import { render, staticRenderFns } from "./ReviewsCategoriesAutoFilter.vue?vue&type=template&id=fd59fb44&scoped=true&"
import script from "./ReviewsCategoriesAutoFilter.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesAutoFilter.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesAutoFilter.vue?vue&type=style&index=0&id=fd59fb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd59fb44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VIcon,VSwitch})
